































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import TableLogoHeader from './TableLogoHeader.vue';
import TableRow from './TableRow.vue';
import PageFooter from '@/components/utils/PageFooter.vue';

@Component({
  components: {
    TableLogoHeader,
    TableRow,
    PageFooter,
  },
})
export default class Table extends Vue {
  @Prop({ type: String, required: true })
  readonly title!: string;

  @Prop({ type: Array, required: true })
  readonly items!: Array<Object>;

  @Prop({ type: Boolean, required: true })
  readonly isActive!: boolean;

  get compHeaderStyle(): string {
    return this.isActive ? 'table-header-title-active' : 'table-header-title-inactive';
  }

  get compTableLineColor(): string {
    return this.isActive ? 'table-line-color-active' : 'table-line-color-inactive';
  }

  maxItemByPage: number = 6;

  currentPageIndex: number = 0;

  get compTableItem(): Array<Object> {
    return this.items
      .sort((firstLine: any, secondLine: any) => {
        const firstLineCreatedDate = new Date(firstLine.date_creation_pedibus).getTime();
        const secondLineCreatedDate = new Date(secondLine.date_creation_pedibus).getTime();
        return secondLineCreatedDate - firstLineCreatedDate;
      })
      .slice(this.currentPageIndex * this.maxItemByPage, this.maxItemByPage * (this.currentPageIndex + 1));
  }

  get compCountPage(): number {
    return Math.ceil(this.items.length / this.maxItemByPage);
  }

  @Emit('leftArrowClicked')
  onLeftArrowClicked(event: any): void {}

  @Emit('rightArrowClicked')
  onRightArrowClicked(event: any): void {}

  leftArrowClicked(): void {
    // this.onLeftArrowClicked({
    //   value: -1,
    //   isActive: this.isActive,
    // });
    if (this.currentPageIndex !== 0) {
      this.currentPageIndex -= 1;
    }
  }

  rightArrowClicked(): void {
    // this.onRightArrowClicked({
    //   value: 1,
    //   isActive: this.isActive,
    // });
    if (this.currentPageIndex !== this.compCountPage - 1) {
      this.currentPageIndex += 1;
    }
  }

  pageNumberclicked(page: number): void {
    this.currentPageIndex = page - 1;
  }
}
